import { AssignmentRuleResponse } from '@cs-cms/types';
import { ExecuteEndpoint } from '../base/BaseApiService';

export class AssignmentsService {
  public async getAssignmentRules(): Promise<AssignmentRuleResponse[]> {
    return ExecuteEndpoint('assignments/rules', 'GET');
  }
}
